import React, { useState, useEffect, useRef } from 'react';

import { MyBridgeLogoMain } from '@mybridge/icons/MyBridgeLogo';
import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalBody,
} from '@mybridge/ui/modal';
import { ModalreelDisplay } from 'v4/components/post/modal-Reel-display';
import { PostBoxFooter } from 'v4/components/post/footer';
import { PostBoxInsightPlate } from 'v4/components/post/insight-plate';
import { ReelBoxFooterActions } from 'v4/components/post/reel-footer-actions';

import { Box, HStack, Stack, VStack } from '@mybridge/ui/layout';
import { CloseButton } from '@mybridge/ui';
import { Spinner } from '@mybridge/ui/spinner';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { Skeleton } from '@mybridge/ui/skeleton';
import { ChevronRight, ChevronLeft } from '@mybridge/icons';

import Link from 'next/link';

import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';

import styles from './image.module.scss';

const ImageModal = ({
  onClose,
  postsData,
  fetchNext,
  hasMore = false,
  postIndex = 0,
  postMediaIndex = 0,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reelsData, setReelsData] = useState(postsData);
  const [activeIndex, setActiveIndex] = useState(postIndex);
  const [activePostIndex, setActivePostIndex] = useState(postMediaIndex);
  const [showMediaPost, setShowMediaPost] = useState(false);
  const playerRefs = useRef([]);

  const postBoxContext = usePostBoxContext({
    post: reelsData[activeIndex],
    initialFetchComments: true,
  });
  const { refetch, refetchComments, post, hasMedia } = postBoxContext ?? {};

  useEffect(() => {
    if (activeIndex !== postIndex) {
      postBoxContext.post = reelsData[activeIndex];
      refetch();
    }
    if (activeIndex >= reelsData.length - 2 && hasMore) {
      fetchNext();
    }
  }, [activeIndex]);

  const handlechangeSwipe = (slider) => {
    setActiveIndex(slider.activeIndex);
  };

  const setPlayerRef = (index) => (ref) => {
    playerRefs.current[index] = ref;
  };

  const handleCommentClicked = () => {
    setExpanded(!expanded);
  };

  const handleClose = () => {
    setExpanded(false);
    setLoading(false);
    setReelsData([]);
    onClose();
  };
  const handleSlider = (dir) => {
    if (
      (activeIndex === 0 && dir === -1) ||
      (activeIndex === reelsData.length - 1 && dir === 1)
    ) {
      return;
    } else {
      if (reelsData[activeIndex].media.length > 0) {
        if (
          activePostIndex + dir < 0 ||
          activePostIndex + dir >= reelsData[activeIndex].media.length
        ) {
          setActivePostIndex(0);
          setActiveIndex(activeIndex + dir);
        } else {
          setActivePostIndex(activePostIndex + dir);
        }
      } else {
        setActivePostIndex(0);
        setActiveIndex(activeIndex + dir);
      }
    }
  };
  return (
    <>
      <Modal isOpen onClose={handleClose} size="full">
        <ModalOverlay />
        <ModalContent style={{ border: '0px' }}>
          <PostBoxContext.Provider
            value={{
              ...(postBoxContext ?? {}),
            }}
            post={reelsData[postIndex]}
          >
            <ModalBody p={0} className="reelModalContainer">
              {loading ? (
                <HStack
                  pos="absolute"
                  top="0"
                  left="0"
                  w="100%"
                  h="100%"
                  alignItems="center"
                  justifyContent="center"
                  zIndex="5"
                  bg="black"
                >
                  <Spinner size="xl" color="white" />
                </HStack>
              ) : (
                ''
              )}

              <HStack
                flexDirection={['column', 'column', 'row']}
                alignItems="stretch"
                spacing={0}
                minH={'100vh'}
                pos="relative"
                p={0}
                bg="black"
              >
                {/* Headear created */}
                <HStack
                  pos="fixed"
                  top="0"
                  left="0"
                  right="0"
                  zIndex="2"
                  px={2}
                  maxW={'100px'}
                  h={'70px'}
                >
                  <HStack bg="transparent" color="white">
                    {!isMobile && <CloseButton onClick={onClose} />}
                  </HStack>
                  <Box p={2}>
                    <Link href="/" as="/">
                      <MyBridgeLogoMain width={isMobile ? '30px' : '44px'} />
                    </Link>
                  </Box>
                </HStack>

                <HStack
                  // flex={"1 1 80%"}
                  flex={1}
                  bg="black"
                  maxH="100%"
                  w="100%"
                  p={0}
                  maxW="100%"
                  position="fixed"
                  top={'70px'}
                  justifyContent="left"
                  spacing={0}
                  overflowY="hidden"
                >
                  <div
                    className={
                      expanded ? styles.container : styles.expendedContainer
                    }
                  >
                    <div>
                      <div className={styles.mainReelSection}>
                        <div className={styles.mediaContainer}>
                          <img
                            src={
                              reelsData?.[activeIndex]?.media?.[postMediaIndex]
                                ?.file
                            }
                          />
                          <div className={styles.btnCont}>
                            {reelsData?.length > 1 && (
                              <>
                                <div
                                  className={`${styles.btns} ${
                                    activeIndex === 0 && styles.btnDisabled
                                  }`}
                                  onClick={() => handleSlider(-1)}
                                >
                                  <ChevronLeft />
                                </div>
                                <div
                                  className={`${styles.btns} ${
                                    activeIndex === reelsData.length - 1 &&
                                    styles.btnDisabled
                                  }`}
                                  onClick={() => handleSlider(1)}
                                >
                                  <ChevronRight />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className={styles.footerAction}>
                          <PostBoxFooter>
                            {reelsData[activeIndex]?.id && (
                              <div className={styles.childContainer}>
                                <PostBoxInsightPlate
                                  isActive={expanded}
                                  handleCommentClicked={handleCommentClicked}
                                  isReel={true}
                                />
                                <ReelBoxFooterActions
                                  isActive={expanded}
                                  handleCommentClicked={handleCommentClicked}
                                  isReel={true}
                                />
                              </div>
                            )}
                          </PostBoxFooter>
                        </div>
                      </div>
                    </div>
                  </div>
                </HStack>

                <Box
                  flex={['auto', 'auto', 1]}
                  maxW={expanded ? '31%' : 0}
                  h="100vh"
                  overflowY="auto"
                  position="fixed"
                  right="0"
                  bg="white"
                  style={{ zIndex: 12 }}
                >
                  {post?.id ? (
                    <DashboardPostBox
                      post={post}
                      isInFrame={true}
                      showMedia={
                        post?.type === 3 || showMediaPost ? true : false
                      }
                      showComments={true}
                      context={postBoxContext}
                    />
                  ) : (
                    <Skeleton
                      maxW={'100%'}
                      maxH="100%"
                      height="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Spinner />
                    </Skeleton>
                  )}
                </Box>
              </HStack>
            </ModalBody>
          </PostBoxContext.Provider>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ImageModal;
